import { defineStore } from 'pinia'

export interface State {
  interval: number
  hasMusic: boolean
  hasSpotify: boolean
  song: string | null
  dev1: string | null
  dev2: string | null
  accessToken: string | null
  tokenExpire: Date | null
}

export const useMainStore = defineStore('main', {
  state: (): State => ({
    interval: 5,
    hasMusic: false,
    hasSpotify: false,
    song: null,
    dev1: null,
    dev2: null,
    accessToken: null,
    tokenExpire: null
  }),

  getters: {
    hasValidAccessToken: (state) => {
      if (!state.accessToken || !state.tokenExpire) {
        return false
      }
      return new Date() < state.tokenExpire
    }
  },

  actions: {
    setInterval(interval: number) {
      if (interval > 0) {
        this.interval = interval
      }
    },

    setHasMusic(hasMusic: boolean) {
      this.hasMusic = hasMusic
    },

    setHasSpotify(hasSpotify: boolean) {
      this.hasSpotify = hasSpotify
    },

    setDev1(dev1: string) {
      this.dev1 = dev1
    },

    setSong(song: string | null) {
      this.song = song
    },

    setDev2(dev2: string) {
      this.dev2 = dev2
    },

    setAccessToken(accessToken: string) {
      this.accessToken = accessToken
    },

    setTokenExpire(tokenExpire: Date) {
      this.tokenExpire = tokenExpire
    },

    cleanStore() {
      this.song = null
    }
  },

  persist: {
    key: 'binome',
    storage: localStorage,
    pick: [
      'interval',
      'hasMusic',
      'hasSpotify',
      'dev1',
      'dev2',
      'accessToken',
      'tokenExpire'
    ]
  }
})
